import oRequest from '@/libsV2/request.js';
const URL = {
    ARCHIVES_WORKORDER_LIST              : "archives/workorder/list", //施工进度----工单列表
    ARCHIVES_WORKORDER_RECTIFY           : 'archives/workorder/rectify',//施工进度----整改通知单
    ARCHIVES_WORKORDER_INFO              : 'archives/workorder/info',// 施工进度----工单信息

};
export const getWorkorderList = (data = {}) => {
    return oRequest.getData(URL.ARCHIVES_WORKORDER_LIST, data);
};
export const getWorkorderRectify = (data = {}) => {
    return oRequest.getData(URL.ARCHIVES_WORKORDER_RECTIFY, data);
};
export const getWorkorderInfo = (data = {}) => {
    return oRequest.getData(URL.ARCHIVES_WORKORDER_INFO, data);
};